import { createVanIconComponent } from "./van"

const Printer = createVanIconComponent("printer")
export default Printer
